import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Dealers
 */
export class DealersListValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<DealerEntity>} deps.items
   * @param {Number} deps.totalPages
   * @param {Number} deps.totalResults
   */

  getItems = () => this._items
}
